<template>
  <div
    class="relatedPackages"
    :data-automation="dataAutomation + '-packages'"
  >
    <span
      v-for="(p, i) in packages"
      :key="i"
      data-automation="package-depends-versions"
    >
      <router-link
        v-if="p.linked_to"
        :to="{ name: 'package', params: { repoId: currentRepoId, packageName: p.name}}"
      >{{ p.name }}</router-link>
      <span v-else>{{ p.name || p.filename }}</span><span
        v-if="getQualifier(p.operator, p.version)"
        data-automation="package-r-versions"
      > {{ getQualifier(p.operator, p.version) }}</span><span v-if="i < packages.length - 1">, </span>
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const operators = [
  '==',
  '>',
  '>=',
  '<',
  '<=',
]

export default {
  name: 'RelatedPackages',
  props: {
    packages: {
      type: Array,
      default: function () { return [] },
    },
    dataAutomation: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: mapState({
    currentRepoId: state => state.repos.currentRepoId,
  }),
  methods: {
    getQualifier: (operator, version) => {
      if (version && operators[operator]) {
        return `(${operators[operator]} ${version})`
      } else if (version) {
        return `(${operator} ${version})`
      } else {
        return ''
      }
    },
  },
}

</script>
